// extracted by mini-css-extract-plugin
export default {"partner_page":"styles_partner_page__xnZNI","top_container":"styles_top_container__PQ0tx","referral_code_container":"styles_referral_code_container__3kF63"};